import React, { useState, useEffect } from 'react';
import taxi from './belfast-cab-tour-blog.png';
import '../Styles.css';

const Packages = () => {
  // State to store the current scroll position
  const [scrollTop, setScrollTop] = useState(0);

  // Set up a scroll event listener to track scroll position
  useEffect(() => {
    const handleScroll = () => {
      setScrollTop(window.scrollY); // Get the scroll position
    };

    window.addEventListener('scroll', handleScroll); // Add event listener
    return () => {
      window.removeEventListener('scroll', handleScroll); // Clean up on component unmount
    };
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        margin: 0,
        padding: 0,
      }}
    >
      {/* Header Section */}
      <header className="Packages-header">
        <div className="animation-wrapper">
          <img
            src={taxi}
            className="taxi"
            alt="taxi"
            style={{
              top: '-2%',
              transform: `translateY(-${scrollTop / 100}%)`, // Dynamic scroll effect
            }}
          />
        </div>
      </header>

      {/* Main Content */}
      <h1 className="Blogs-header" style={{ textAlign: 'center', marginBottom: 0 }}>
        <p>My Unforgettable Belfast Cab Tour Experience</p>
      </h1>
      <h2 className="Blogs-content" style={{ textAlign: 'left', marginBottom: 0 }}>
        <p>
          When our cruise ship docked in Belfast, I had no idea I was about to have one of the most
          eye-opening and moving experiences of my life. I’d read about the city’s history and the
          Troubles before our trip, but nothing prepared me for the depth of knowledge, passion,
          and storytelling I would encounter on my Belfast Cab Tour.
        </p>
        <p>
          Our driver Marty picked us up right at the port, which was so convenient and allowed us to
          make the most of our short time in the city. From the moment we got in, he was friendly,
          warm, and eager to share the history of Belfast. What struck me the most was how balanced
          and insightful he was. He explained the complexities of Northern Ireland's Troubles in
          a way that made it easy to understand, even for someone like me who didn’t grow up
          learning about this part of the world.
        </p>
        <p>
          We spent much of the tour exploring the famous political murals on Falls Road and Shankill
          Road, two areas that were at the heart of the conflict. Seeing these murals up close
          was incredibly powerful. Each one tells a story—of loss, hope, defiance, and resilience.
          Our guide explained the significance of the art, and I felt like I was being given
          a window into Belfast’s soul.
        </p>
        <p>
          What I appreciated most was how the tour wasn’t just about the past. It was about how
          Belfast has moved forward and the ongoing journey of reconciliation. It was humbling
          to see how people are working to build bridges in a city that has endured so much.
        </p>
        <p>
          Before we knew it, the tour was over, and our guide dropped us off back at the cruise ship.
          I was genuinely sad to leave, but I came away with a deeper understanding and appreciation
          for Belfast and its people.
        </p>
        <p>
          If you’re visiting Belfast, whether for a day or longer, I cannot recommend this tour enough.
          It’s not just a cab ride; it’s a journey through history, culture, and humanity that
          I will never forget.
        </p>
        <p>
          Thank you to my amazing guide, Marty, for sharing your city with me in such a meaningful way!
        </p>
      </h2>

      <h1 className="Blogs-header" style={{ textAlign: 'center', marginBottom: 0 }}>
        <p>The Belfast Workhouse and the Famine</p>
      </h1>
      <h2 className="Blogs-content" style={{ textAlign: 'left', marginBottom: 0 }}>
        <p>
          Opened in 1841, the Belfast Union Workhouse was built to accommodate 1,000 inmates.
          Today, the site is home to Belfast City Hospital, with the Fever Hospital as one of the few
          original buildings still standing.
        </p>
        <p>
          Although Belfast appeared more prosperous than other Irish cities in the 1840s,
          poverty was widespread due to rapid population growth, overcrowding, and poor sanitation.
          By the mid-19th century, Belfast had one of the UK’s highest death rates, with infant mortality
          so severe that the average age at death in 1851 was just nine years.
        </p>
        <h1 className="Blogs-header" style={{ textAlign: 'center', marginBottom: 0 }}>
          <p>Impact of the Famine</p>
        </h1>
        <p>
          The potato blight arrived in 1845 when the workhouse was already operating, though only those in
          extreme distress sought admission. By 1846, famine and a textile industry downturn filled the
          workhouse to capacity, with local soup kitchens feeding 3,000 people daily.
        </p>
        <p>
          By spring 1847, the workhouse housed 1,500 people, forcing the addition of tents and sheds. Deaths from
          starvation and disease were reported daily, with nearly 1,500 deaths recorded in the workhouse that year
          alone, compared to 200–300 annually in other years.
        </p>
        <p>
          Belfast also saw an influx of rural Irish seeking work, food, or emigration opportunities, as well as Irish
          paupers expelled from Britain, particularly Scotland. This population growth makes it difficult to determine
          how many famine-related deaths occurred in Belfast, though the toll was significant.
        </p>
      </h2>

      {/* Footer Section */}
      <footer
        style={{
          textAlign: 'center',
          padding: '1rem',
          backgroundColor: '#333',
          color: '#fff',
          marginTop: 'auto',
        }}
      >
        &copy; 2025{' '}
        <a
          href="https://belfastcabtour.com"
          style={{
            color: '#fff',
            textDecoration: 'none',
          }}
        >
          belfastcabtour.com
        </a>
        . All rights reserved.
      </footer>
    </div>
  );
};

export default Packages;
